var placements = [
    {
      allowCheckout: false,
      domID: "bread-placement-1",
    },
    {
      allowCheckout: false,
      domID: "bread-placement-2",
    },
];
  
BreadPayments.setup({ 
  integrationKey: "de29f876-6b1f-4df7-b018-457044844c51"
});
  
BreadPayments.registerPlacements(placements);
      
BreadPayments.on("INSTALLMENT:APPLICATION_CHECKOUT", () => {});
  
BreadPayments.on("INSTALLMENT:APPLICATION_DECISIONED", () => {});
 